import React, { Component } from 'react';
import { Modal, Button, Row, Col } from 'antd';
import WorkOperationsTable from '../WorkDetailsTable/WorkOperationsTable';
import IconDelete from '$app/components/vendor/WorkOperationEditor/IconDelete';
import { applyVat, substractVat } from '$app/utils/util';

const validator = (form, columnKey) => (rule, value, callback) => {
  const errors = [];
  if (columnKey === 'price' && typeof value !== 'number') {
    errors.push(new Error(`required`));
  }
  return callback(errors);
};

export default class GarageCAndDModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing:'all',
      lineItem: props.editableLineItem || {},
      vatExempt: props.editableLineItem && props.editableLineItem.vatExempt,
    };
  }

  get columns() {
    return [
      {
        title: '',
        key: 'workSummary',
        editable: false,
        width: '14%',
      },
      {
        title: '',
        key: 'blank',
        children: [
          {
            title: '',
            key: 'blank1',
            align: '',
            width: '10%',
          },
          {
            title: '',
            key: 'blank2',
            align: '',
            width: '10%',
          },
          {
            title: '',
            key: 'blank3',
            align: '',
            width: '10%',
          },
        ],
      },
      {
        title: 'Customer',
        key: 'garage-group',
        children: [
          {
            title: 'Total (pre VAT)',
            key: 'fixedCost',
            editable: (this.state.editing==='fixedCost' || this.state.editing==='all'),
            input: {
              type: 'number',
              min: 0,
              onChange: (val) => {
                const oldValues = this.state.lineItem;
                const updatedValues = { fixedCost: val, fixedCostWithVAT: this.state.vatExempt ? val : applyVat(val)};
                this.setState({ editing: 'fixedCost', lineItem: Object.assign({}, oldValues, updatedValues)});
              }
            },
            displayPrice: true,
            align: 'right',
            width: '10%',
          },
          {
            title: 'Total (inc. VAT)',
            key: 'fixedCostWithVAT',
            editable: (this.state.editing==='fixedCostWithVAT' || this.state.editing==='all'),
            input: {
              type: 'number',
              min: 0,
              onChange: (val) => {
                const oldValues = this.state.lineItem;
                const updatedValues = {fixedCost: this.state.vatExempt ? val : substractVat(val), fixedCostWithVAT: val};
                this.setState({ editing: 'fixedCostWithVAT',lineItem: Object.assign({}, oldValues, updatedValues)});
              }
            },
            displayPrice: true,
            align: 'right',
            width: '10%',
          },
        ],
      },
    ];
  }

  get footer() {
    const { onCancel, isSaving } = this.props;
    return [
      <Row type="flex" justify="space-between" style={{ textAlign: 'left' }}>
        <Col>
          <Button type="link" key="back" onClick={this.handleOnDelete} style={{color: '#fd5555', lineHeight: 1}}>
            <IconDelete /> Delete
          </Button>
        </Col>
        <Col>
          <Button key="back" onClick={onCancel}>
            Cancel
          </Button>
          <Button key="submit" type="primary" onClick={this.handleOnSave} loading={isSaving}>
            Save
          </Button>
        </Col>
      </Row>
    ];
  }

  handleOnDelete =  () => this.props.onDelete({ ...this.state.lineItem, status: 'deleted' });

  handleOnSave = () => this.props.onSave(this.state.lineItem);

  render() {
    const { visible = false, onCancel } = this.props;
    return (
      <Modal
        title={this.props.title || 'Edit Driver Tip price'}
        visible={visible}
        onOk={this.handleOnSave}
        onCancel={onCancel}
        width={1000}
        footer={this.footer}
        keyboard={false}
      >
        <Row style={{ marginBottom: 24, minHeight: 180 }}>
          <Col span={24}>
            <WorkOperationsTable
              key="WorkDetailsTableEditor"
              columns={this.columns}
              dataSource={[this.state.lineItem]}
              validator={validator}
            />
          </Col>
        </Row>
      </Modal>
    );
  }
}
